import { OfflineDataFetcher } from '@skinsoft/data-store/src/offline/offline-data-fetcher';

import { Item, Wemi, WemiUtils } from '@skinsoft/entity/'
import { wemiSelectors } from '@skinsoft/search-data-store';
import { matchesRegex } from '@skinsoft/utils';
import { Observable } from 'rxjs';
import { map, pluck, tap, } from 'rxjs/operators';

export type WemiOfflineDataFetcher = ItemOfflineDataFetcher;

export class ItemOfflineDataFetcher extends OfflineDataFetcher<Item, Wemi>{

    constructor(cacheKey: string) {
        super(cacheKey);
    }

    public fetchOneFromId(id: string): Observable<Item> {
        return super.fetchOneFromId(id)
            .pipe(
                map(obj => obj || {}),
                pluck('item')
            )
    }

    public fetchWemiFromId(id: string): Observable<Wemi> {
        return WemiUtils.getWemiFromItem(id);
    }

    protected idMatcher(entity: any, id: string) {
        if (entity.item) {
            return entity.item.id === id;
        }
        return false;
    }

    protected async queryTextFilter(entity: Wemi, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()

        // item title match 
        const title: string = wemiSelectors.title(entity, locale);
        const titleMatch = title ? matchesRegex(lowerCaseQueryText, title.toLowerCase()) : false;

        // item identifier match
        const identifier: string = wemiSelectors.inventoryNumber(entity, locale);
        const identifierMatch = identifier ? matchesRegex(lowerCaseQueryText, identifier.toLowerCase()) : false;

        return titleMatch || identifierMatch;
    }
}